import { RemoteActivitiesPendingByProfessionals } from 'data/usecases';
import { ActivitiesPendingByProfessionalsUseCaseInterface } from 'domain/usecases';
import { makeApiUrlActivitiesPendingByProfessionals } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeActivityPendingByProfessionals =
  (): ActivitiesPendingByProfessionalsUseCaseInterface =>
    new RemoteActivitiesPendingByProfessionals(
      makeApiUrlActivitiesPendingByProfessionals(),
      makeAxiosHttpClient(),
    );
